"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateText = exports.truncateMiddle = void 0;
const truncateMiddle = (str) => {
    if (str.length > 20) {
        return str.substr(0, 8) + "....." + str.substr(str.length - 8, str.length);
    }
    return str;
};
exports.truncateMiddle = truncateMiddle;
const truncateText = (str, length, position) => {
    if (str.length > 20) {
        return position === "center"
            ? str.substr(0, length) + "....." + str.substr(str.length - length, str.length)
            : position === "start"
                ? "....." + str.substr(0, length)
                : str.substr(0, length) + ".....";
    }
    return str;
};
exports.truncateText = truncateText;
//# sourceMappingURL=_helper.js.map